import { type SceneControl, lib, use } from '@anov/3d-core'
import ACESFilmicToneMappingShader from './shader/mapping'

const { CopyShader, ShaderPass } = lib

const addmappingExposurePass = (exposure = 0.5, sceneControl: SceneControl) => {
  const { scene, camera } = use.useScene(sceneControl)
  const composer = sceneControl.context.storeManagement.get('composer') as lib.EffectComposer | undefined

  if (!scene || !camera)
    throw new Error('scene or camera is not defined,')

  if (!composer)
    throw new Error('composer is not defined, please initPostEffects first')

  const effectCopy = new ShaderPass(CopyShader)
  effectCopy.renderToScreen = true

  ACESFilmicToneMappingShader.uniforms.exposure.value = exposure

  const mappingExposurePass = new ShaderPass(ACESFilmicToneMappingShader)

  composer.addPass(effectCopy)
  composer.addPass(mappingExposurePass)

  return {
    clean: () => {
      composer.removePass(effectCopy)
      composer.removePass(mappingExposurePass)
    },

  }
}

export default addmappingExposurePass